import * as React from "react";
import PropTypes from "prop-types";
import { Icon as PLIcon } from "@lululemon/ui-library";
import "./icon.scss";

export default function Icon({
  content: Svg,
  className,
  PLIconContent,
  glyph,
  children,
  ...rest
}) {
  if (PLIconContent) {
    return <PLIcon content={PLIconContent} />;
  }

  if (glyph?.url || Svg?.url) {
    return (
      <img
        className={className || "svg-icon"}
        src={glyph?.url || Svg?.url}
        {...rest}
      />
    );
  }

  if (Svg) {
    return (
      <Svg className={className || "svg-icon"} {...rest}>
        {children}
      </Svg>
    );
  }

  return null;
}

Icon.propTypes = {
  content: PropTypes.elementType.isRequired,
  className: PropTypes.string,
  PLIconContent: PropTypes.element
};

Icon.defaultProps = {
  className: undefined,
  PLIconContent: null
};
